import { Button } from "@ui/primitives/Button";
import type { Ref } from "react";

export interface ReactionTriggerProps {
  label: string;
  onPress: () => void;
  ref?: Ref<HTMLButtonElement>;
}

/**
 * The affordance that opens the reaction picker on pointer devices. Always in the DOM and reachable
 * by keyboard — it only *appears* on hover, because a control that exists solely on hover is not
 * reachable at all for anyone tabbing through the thread.
 */
export function ReactionTrigger({ label, onPress, ref }: ReactionTriggerProps) {
  return (
    <Button
      ref={ref}
      aria-label={label}
      onPress={onPress}
      className="flex size-7 shrink-0 cursor-pointer items-center justify-center rounded-full text-neutral-400 opacity-0 outline-none transition-opacity hover:bg-neutral-50 hover:text-neutral-600 focus-visible:opacity-100 focus-visible:ring-2 focus-visible:ring-red-300 group-hover/message:opacity-100"
    >
      <svg
        aria-hidden="true"
        className="size-4"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.75"
        viewBox="0 0 24 24"
      >
        <circle cx="12" cy="12" r="9" />
        <path d="M8.5 14.5a4.5 4.5 0 0 0 7 0" strokeLinecap="round" />
        <path d="M9 9.5h.01M15 9.5h.01" strokeLinecap="round" />
      </svg>
    </Button>
  );
}
